var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiLogoMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_28584",
    "data-name": "Group 28584",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 175.233,
    height: 25.547,
    viewBox: "0 0 175.233 25.547",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3168",
    "data-name": "Rectangle 3168",
    width: 175.233,
    height: 25.547,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4525",
    "data-name": "Group 4525",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12561",
    "data-name": "Path 12561",
    d: "M26.069,20.528a2.665,2.665,0,0,0-.689.125L16.732,2.417A2.749,2.749,0,0,0,14.288.725a2.682,2.682,0,0,0-2.444,1.692L3.133,20.653a2.253,2.253,0,0,0-.689-.125,2.413,2.413,0,1,0,1.5.5L12.6,2.793A1.937,1.937,0,0,1,14.288,1.6,1.937,1.937,0,0,1,15.98,2.793l8.648,18.236a2.449,2.449,0,1,0,3.948,1.943,2.543,2.543,0,0,0-2.507-2.444M2.444,24.413a1.5,1.5,0,0,1,0-3.008,1.525,1.525,0,0,1,1.5,1.5,1.485,1.485,0,0,1-1.5,1.5m23.625,0a1.5,1.5,0,1,1,1.5-1.5,1.485,1.485,0,0,1-1.5,1.5",
    transform: "translate(0 -0.271)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12562",
    "data-name": "Path 12562",
    d: "M55.483,20.59V5.55a2.444,2.444,0,1,0-.877,0V20.59a2.434,2.434,0,1,0,2.883,2.381,2.485,2.485,0,0,0-2.005-2.381M53.54,3.169a1.5,1.5,0,1,1,3.008,0,1.525,1.525,0,0,1-1.5,1.5,1.569,1.569,0,0,1-1.5-1.5m1.5,21.244a1.5,1.5,0,1,1,1.5-1.5,1.485,1.485,0,0,1-1.5,1.5",
    transform: "translate(-19.637 -0.271)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12563",
    "data-name": "Path 12563",
    d: "M86.239,18.683a2.629,2.629,0,0,0-1.025-2.228,13.423,13.423,0,0,0-3.689-1.639,26.153,26.153,0,0,1-4.218-1.7q-4.236-2.288-4.235-6.165a6,6,0,0,1,1.136-3.6A7.413,7.413,0,0,1,77.47.888,12.286,12.286,0,0,1,82.244,0a11.169,11.169,0,0,1,4.747.965A7.554,7.554,0,0,1,90.227,3.69a7.057,7.057,0,0,1,1.146,3.649.339.339,0,0,1-.338.347H86.578a.337.337,0,0,1-.332-.323A3.241,3.241,0,0,0,85.181,5.03a4.424,4.424,0,0,0-3.023-.948,4.726,4.726,0,0,0-2.92.794A2.507,2.507,0,0,0,78.2,6.968,2.4,2.4,0,0,0,79.417,9a13.793,13.793,0,0,0,3.6,1.537,15.536,15.536,0,0,1,6.37,3.262,6.5,6.5,0,0,1,2,4.85,5.984,5.984,0,0,1-2.442,5.063,10.687,10.687,0,0,1-6.575,1.836,12.7,12.7,0,0,1-5.225-1.05,8.272,8.272,0,0,1-3.6-2.878,7.281,7.281,0,0,1-1.231-3.888.339.339,0,0,1,.339-.347h4.473a.335.335,0,0,1,.33.325q.19,3.791,4.91,3.791a4.786,4.786,0,0,0,2.852-.743,2.417,2.417,0,0,0,1.025-2.075",
    transform: "translate(-24.242 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12564",
    "data-name": "Path 12564",
    d: "M127.247,4.695H120.13V24.91a.5.5,0,0,1-.5.5h-4.125a.5.5,0,0,1-.5-.5V4.695h-7.014a.5.5,0,0,1-.5-.5V1.044a.5.5,0,0,1,.5-.5h19.255a.5.5,0,0,1,.5.5V4.2a.5.5,0,0,1-.5.5",
    transform: "translate(-37.376 -0.204)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12565",
    "data-name": "Path 12565",
    d: "M164.27.545a.554.554,0,0,1,.555.555V16.922a8.386,8.386,0,0,1-2.553,6.455,9.845,9.845,0,0,1-6.976,2.374,9.952,9.952,0,0,1-6.917-2.306,8.24,8.24,0,0,1-2.613-6.336V1.1a.554.554,0,0,1,.555-.555h4.014a.555.555,0,0,1,.555.555V16.956a4.737,4.737,0,0,0,1.17,3.561,4.49,4.49,0,0,0,3.236,1.118q4.32,0,4.389-4.542V1.1a.554.554,0,0,1,.555-.555Z",
    transform: "translate(-51.665 -0.204)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12566",
    "data-name": "Path 12566",
    d: "M184.555,24.831V1.124a.579.579,0,0,1,.578-.579h7.072a11.622,11.622,0,0,1,5.866,1.477,10.311,10.311,0,0,1,4.039,4.2,12.96,12.96,0,0,1,1.451,6.19v1.144a12.99,12.99,0,0,1-1.426,6.165,10.206,10.206,0,0,1-4.021,4.184,11.7,11.7,0,0,1-5.857,1.5h-7.123a.579.579,0,0,1-.578-.578m5.123-20.136v16.6h2.476a5.565,5.565,0,0,0,4.594-1.964,8.871,8.871,0,0,0,1.622-5.618V12.4A9.014,9.014,0,0,0,196.8,6.65a5.546,5.546,0,0,0-4.593-1.955Z",
    transform: "translate(-66.146 -0.204)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12567",
    "data-name": "Path 12567",
    d: "M227.583,25.409h-4.006a.559.559,0,0,1-.558-.559V1.1a.559.559,0,0,1,.558-.559h4.006a.559.559,0,0,1,.559.559V24.85a.559.559,0,0,1-.559.559",
    transform: "translate(-80.506 -0.204)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12568",
    "data-name": "Path 12568",
    d: "M260.42,13.337a15.015,15.015,0,0,1-1.3,6.438,9.78,9.78,0,0,1-3.714,4.269,10.975,10.975,0,0,1-11.058.017,9.871,9.871,0,0,1-3.757-4.244,14.575,14.575,0,0,1-1.349-6.344v-1.23a14.941,14.941,0,0,1,1.323-6.464,9.861,9.861,0,0,1,3.741-4.286,10.961,10.961,0,0,1,11.049,0A9.859,9.859,0,0,1,259.1,5.78a14.9,14.9,0,0,1,1.324,6.447Zm-5.191-1.127a10.462,10.462,0,0,0-1.4-5.943,4.947,4.947,0,0,0-7.975-.026,10.342,10.342,0,0,0-1.418,5.883v1.213a10.589,10.589,0,0,0,1.4,5.909,4.9,4.9,0,0,0,7.992.076,10.54,10.54,0,0,0,1.4-5.9Z",
    transform: "translate(-86.563 0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiLogoMobile);
export default __webpack_public_path__ + "static/media/ai-logo-mobile.78252b87bd55298273b3a70639f669ef.svg";
export { ForwardRef as ReactComponent };